var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.handleClick}},[_c('v-tabs',_vm._g(_vm._b({},'v-tabs',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }